import { BusinessChangeListSchema, ChangeImpactPreviewSchema, DeliveryBatchResponseSchema,
  DeliveryRecordListSchema, DeliveryWriteResponseSchema,
  type ConfirmChangeRequest, type CorrectDeliveryRequest, type DeliveryBatchResponse,
  type DeliveryRecordList, type DeliveryWriteResponse, type RegisterDeliveriesBatchRequest,
  type RegisterDeliveryRequest } from '@youkuai/contracts';

import { apiRequest } from './project-api.ts';

function project(projectId: string): string { return `/projects/${encodeURIComponent(projectId)}`; }
function write(key: string, body: unknown): RequestInit {
  return { method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': key },
    body: JSON.stringify(body) };
}
export function listProjectDeliveries(token: string, projectId: string): Promise<DeliveryRecordList> {
  return apiRequest(`${project(projectId)}/deliveries`, token).then((value) => DeliveryRecordListSchema.parse(value));
}
export function listContentDeliveries(token: string, projectId: string, contentId: string): Promise<DeliveryRecordList> {
  return apiRequest(`${project(projectId)}/contents/${encodeURIComponent(contentId)}/deliveries`, token)
    .then((value) => DeliveryRecordListSchema.parse(value));
}
export function registerDelivery(input: { token: string; projectId: string; contentId: string; key: string;
  delivery: RegisterDeliveryRequest }): Promise<DeliveryWriteResponse> {
  return apiRequest(`${project(input.projectId)}/contents/${encodeURIComponent(input.contentId)}/deliveries`,
    input.token, write(input.key, input.delivery)).then((value) => DeliveryWriteResponseSchema.parse(value));
}
export function registerDeliveriesBatch(input: { token: string; projectId: string; key: string;
  batch: RegisterDeliveriesBatchRequest }): Promise<DeliveryBatchResponse> {
  return apiRequest(`${project(input.projectId)}/deliveries/batch`, input.token, write(input.key, input.batch))
    .then((value) => DeliveryBatchResponseSchema.parse(value));
}
export function previewBusinessChange(input: { token: string; projectId: string; kind: string; targetId: string;
  expectedVersion: number; reason: string }) {
  return apiRequest(`${project(input.projectId)}/business-changes/preview`, input.token,
    { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ kind: input.kind,
      targetId: input.targetId, expectedVersion: input.expectedVersion, reason: input.reason }) })
    .then((value) => ChangeImpactPreviewSchema.parse(value));
}
export function withdrawDelivery(input: { token: string; projectId: string; deliveryId: string; key: string;
  change: ConfirmChangeRequest }): Promise<DeliveryWriteResponse> {
  return apiRequest(`${project(input.projectId)}/deliveries/${encodeURIComponent(input.deliveryId)}/withdraw`,
    input.token, write(input.key, input.change)).then((value) => DeliveryWriteResponseSchema.parse(value));
}
export function correctDelivery(input: { token: string; projectId: string; deliveryId: string; key: string;
  change: CorrectDeliveryRequest }): Promise<DeliveryWriteResponse> {
  return apiRequest(`${project(input.projectId)}/deliveries/${encodeURIComponent(input.deliveryId)}/correct`,
    input.token, write(input.key, input.change)).then((value) => DeliveryWriteResponseSchema.parse(value));
}
export function listBusinessChanges(token: string, projectId: string) {
  return apiRequest(`${project(projectId)}/business-changes`, token).then((value) => BusinessChangeListSchema.parse(value));
}
/** BUG-0105：项目经理在结算前调整内容的结算档位（走预览 → 确认两步）。 */
export function changeContentVariant(input: { token: string; projectId: string; contentId: string; key: string;
  change: { expectedVersion: number; previewId: string; previewVersion: number; reason: string; targetVariantKey: string } }):
  Promise<{ contentId: string; version: number; status: string; replayed: boolean }> {
  return apiRequest(`${project(input.projectId)}/contents/${encodeURIComponent(input.contentId)}/change-variant`,
    input.token, write(input.key, input.change)) as Promise<{ contentId: string; version: number; status: string;
      replayed: boolean }>;
}
